module.exports = __webpack_public_path__ + "img/collection-engagementRingsHalo@2x.9e77b88.jpg";